module.exports = __webpack_public_path__ + "static/img/sx.4d1a27e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sx.jpg
// module id = zPTt
// module chunks = 1